import React, { useState, useEffect } from 'react'
import Chip from '@material-ui/core/Chip'
import { FaHashtag } from 'react-icons/fa'

const TaskCode = props => {
  return (
    props.code > 0 && (
      <div className="ltr">
        <Chip
          className={`TaskCode ${props.reserve ? 'reserve' : ''}`}
          icon={props.reserve ? '' : <FaHashtag />}
          label={props.reserve ? 'R ' + props.code : props.code}
          clickable
          color="primary"
        />
      </div>
    )
  )
}

export default TaskCode
